export const baseURL = process.env.NODE_ENV !== 'production' ? window.location.origin + '/api' : window.$cfg ? window.$cfg.baseURL : window.location.origin

export const homeURL = window.$cfg ? window.$cfg.homeURL : window.location.origin

export const mpQrcodeImg = process.env.NODE_ENV !== 'production' ? './img/mp_dev.jpg' : './img/mp.jpg'

export const uniappQrcodeImg = process.env.NODE_ENV !== 'production' ? './img/uniapp_dev.jpg' : './img/uniapp.jpg'